module.exports = __webpack_public_path__ + "static/media/1.0866fc65.jpeg";